const reviews = [
  {   
    clientName: "MUKESH LABANA",
    companyName: "GDALA LOGISTICS",
    review:
      "Before using Saral Way, managing e-way bills was a nightmare. Now, with automatic extensions and real-time tracking, our team saves hours of manual work every day. The software is user-friendly and a must-have for transporters!"
  },
  {   
    clientName: "LAKSHANK SHARMA",
    companyName: "DELHI PEPSU",
    review:
      "We purchased their software 2–3 years ago, and it has been excellent. It is easy to understand, reliable, and the customer support is very good. The software makes creating LR, challan, and day-to-day transactions fast and simple."
  },
  {   
    clientName: "RAJ PATNI",
    companyName: "VEER EXPRESS",
    review:
      "We have been using this software for almost two years, and the experience has been amazing. It has significantly improved our workflow, allowing us to complete tasks three times faster and with greater accuracy than other software we used. Its intuitive interface and powerful features have streamlined our entire process."
  },
  {   
    clientName: "ANAND JHA",
    companyName: "GURU LOGISTICS",
    review:
      "With Saral Transport, we can track all our shipments, payments, and pending bilties in one place. Our clients also appreciate the portal where they can check their deliveries and dues. It has greatly improved our efficiency and customer satisfaction."
  },
  {   
    clientName: "PARTH KARAVADIYA",
    companyName: "SANTOSHI LOGISTICS",
    review:
      "The team at Tech It Easy provides outstanding support. Any issue we face is resolved quickly. Saral E-Way is reliable, cost-effective, and has everything a transporter needs!"
  },
  {   
    clientName: "SATNAM SINGH",
    companyName: "ABHIRAJ TRANSPORT",
    review:
      "Saral Way and Saral Transport have scaled with our business needs. The e-way bill consolidation and transporter-change features are very helpful. It is a well-thought-out solution for logistics companies."
  },
  {   
    clientName: "CHANDRAKANT PATEL",
    companyName: "ANKLESHWAR VADODARA ROADWAYS",
    review:
      "Tech It Easy developed a new web version of our transport software. We were previously using a desktop version and wanted to upgrade. It has now been three years of service, and the experience has been extremely good. They resolve our queries quickly—thank you!"
  },
  {   
    clientName: "Muzammi Ghanchi",
    companyName: "SAIKRUPA TRANSPORT",
    review:
      "We at Saikrupa Transport have been using your software for the last three years, and we are very satisfied with it. You handle all transport-related tasks with great care, and your services are very helpful. After our previous bad experiences, your Tech It Easy service has given us great satisfaction. Whether it’s e-way bill processing or accounting and billing, you complete our work very quickly. We are happy to say that we are your satisfied customers."
  }
];

export { reviews };